import React from 'react';

import { BsQuestionCircle } from 'react-icons/bs';
import { HiPhone } from 'react-icons/hi';
import { MdCheck, MdClose } from 'react-icons/md';
import { useWindowSize } from 'usehooks-ts';

import Text from '@/tayara-kit/Text';
import Tooltip from '@/tayara-kit/Tooltip';

type OfferData = {
  title: string;
  description: string;
  individual: boolean;
  profesional: boolean;
};

type OffersData = {
  [key: string]: OfferData[];
};

export const FourthSectionContent = ({ handleActionClick }: any) => {
  const windowSize = useWindowSize();
  const offersData: OffersData = {
    'Publication et Exploration': [
      {
        title: 'Navigation et recherche',
        description: 'Accès libre sur le site et à la recherche de produits.',
        individual: true,
        profesional: true,
      },
      {
        title: 'Publication des annonces',
        description:
          'Capacité de publier des annonces pour vendre des produits.',
        individual: true,
        profesional: true,
      },
      {
        title: 'Exploration des boutiques',
        description:
          'Exploration des boutiques et des produits disponibles sur la plateforme.',
        individual: true,
        profesional: true,
      },
      {
        title: 'Accès aux détails des annonces',
        description:
          'Accès aux détails des annonces, y compris les descriptions et les photos.',
        individual: true,
        profesional: true,
      },
      {
        title: 'Recherche sauvegardée',
        description:
          'Option de sauvegarder des annonces pour un accès facile ultérieur.',
        individual: true,
        profesional: true,
      },
    ],
    Profil: [
      {
        title: 'Création de compte',
        description: 'Possibilité de créer un compte utilisateur gratuitement.',
        individual: true,
        profesional: true,
      },
      {
        title: 'Gestion de profil',
        description:
          'Possibilité de gérer et de mettre à jour son propre profil.',
        individual: true,
        profesional: true,
      },
      {
        title: 'Communication',
        description:
          'Possibilité de communiquer avec les vendeurs via la messagerie interne.',
        individual: true,
        profesional: true,
      },
    ],
    'Options de Mise en Avant': [
      {
        title: 'Annonces gratuites',
        description: 'Publication d`annonces gratuites.',
        individual: true,
        profesional: true,
      },
      {
        title: 'Mise en avant des produits',
        description:
          'Booster vos produits grâce aux services proposés sur le site.',
        individual: true,
        profesional: true,
      },
    ],
    'Avantages Professionnels': [
      {
        title: 'Boutique en ligne',
        description:
          'Vous aurez votre boutique en ligne et tous vos produits y seront rattachés.',
        individual: false,
        profesional: true,
      },
      {
        title: 'Visibilité accrue',
        description:
          'Votre boutique sera toujours accessible sur la première marketplace du marché tunisien.',
        individual: false,
        profesional: true,
      },
      {
        title: 'Tableau de bord analytiques',
        description:
          'Des rapports détaillés seront inclus dans votre boutique, montrant les vues, clics et leads par bien et par boutique.',
        individual: false,
        profesional: true,
      },
      {
        title: 'Promotions marketing',
        description:
          'Votre boutique sera promue sur nos réseaux sociaux et à travers nos campagnes publicitaires.',
        individual: false,
        profesional: true,
      },
      {
        title: 'Tarifs privilégiés',
        description:
          'Des tarifs spéciaux et des gratuités sont offerts aux clients PRO, avec facilités de paiement.',
        individual: false,
        profesional: true,
      },
      {
        title: 'Account manager',
        description:
          'Un commercial dédié vous accompagnera tout au long de votre souscription.',
        individual: false,
        profesional: true,
      },
      {
        title: 'Transfert de compétence',
        description:
          'Formation, bonne pratique, suivi , conseil et assistance.',
        individual: false,
        profesional: true,
      },
      {
        title: 'Design pro pour les annonces',
        description: 'Vos annonces seront mises en avant avec votre logo.',
        individual: false,
        profesional: true,
      },
    ],
    Support: [
      {
        title: 'Support prioritaire',
        description:
          'Un coordinateur des ventes vous aidera à gérer vos Jetons en ligne et à optimiser vos ventes.',
        individual: false,
        profesional: true,
      },
    ],
  };

  function scrollToTop() {
    window.scrollTo({
      top: 700, // Scroll to the top of the page
      behavior: 'smooth', // You can use 'auto' or 'smooth' for scrolling behavior
    });
  }

  const handleFirstSectionRedirection = () => {
    handleActionClick('Commencez gratuitement');
    scrollToTop();
  };

  const handleSecondSectionRedirection = () => {
    handleActionClick('Boostez vos annonces efficacement');
    scrollToTop();
  };

  return (
    <>
      <div className="flex flex-col mx-auto justify-center items-center w-5/6  md:w-4/6 h-fit mt-12 md:mt-20">
        <Text
          text="Choisissez votre offre"
          as="h3"
          className="text-2xl md:text-3xl font-bold text-center text-primary"
        />
        <Text
          text="Explorez en détail les avantages de nos différentes offres pour trouver celle qui correspond le mieux à vos besoins."
          as="p"
          className="text-sm md:text-lg text-center text-neutral-700 mt-7"
        />
      </div>
      <Text
        text="Comparez nos offres"
        as="h3"
        className="text-lg  xl:text-2xl font-bold text-center text-neutral-700 my-12"
      />
      <div className="flex items-center justify-center bg-white/40">
        <div className=" -my-2 overflow-x-auto sm:-mx-6 lg:-mx-8 rounded-3xl outline outline-[1px] outline-dashed outline-primary/50 p-5 md:p-10 !mx-auto ">
          <div className="flex  min-w-full py-2 align-middle md:px-6 lg:px-8">
            <div className="relative pb-8 overflow-x-auto md:rounded-lg">
              <table className="min-w-full table-fixed  ">
                <thead>
                  <tr className={`flex w-full justify-end  bg-white/50 pt-4`}>
                    {windowSize.width > 1200 && (
                      <th scope="col" className="w-[50rem] "></th>
                    )}
                    <th
                      scope="col"
                      className="w-[7rem] md:w-[9rem] font-extrabold"
                    >
                      Particuliers
                    </th>
                    <th
                      scope="col"
                      className="w-[7rem] md:w-[9rem] font-extrabold"
                    >
                      Professionnels
                    </th>
                  </tr>
                </thead>
                <tbody className=" bg-white/60 ">
                  {/* Fixed rows */}
                  {Object.keys(offersData).map((key) => (
                    <React.Fragment key={key}>
                      <tr className="flex items-center mb-2">
                        <td
                          colSpan={4}
                          className="w-[12rem] md:w-[15rem] mx-2 md:mx-10 my-2 text-sm md:text-md lg:text-base font-extrabold text-start text-neutral-700 truncate"
                        >
                          {key}
                        </td>
                      </tr>
                      {offersData[key]?.map((offer, index) => {
                        // Popover description on small devices
                        const DescriptionPopoverInfo = () => (
                          <div className=" w-[15rem] p-3 relative ">
                            {offer.description ===
                            'Booster vos produits grâce aux services proposés sur le site.' ? (
                              <p className="text-xs text-neutral-700 leading-tight">
                                {offer.description}

                                <span
                                  className="text-2xs md:text-xs font-semibold ml-2 cursor-pointer underline"
                                  onClick={handleSecondSectionRedirection}
                                >
                                  (Voir offres)
                                </span>
                              </p>
                            ) : (
                              <p className="text-xs text-neutral-700 leading-tight">
                                {offer.description}
                              </p>
                            )}
                          </div>
                        );
                        return (
                          <tr
                            key={index}
                            className="flex items-center my-5 bg-neutral-100/80 py-4"
                          >
                            <td className="!p-0 w-[12rem] md:w-[15rem] mx-2 md:mx-10 flex justify-start items-center gap-x-0 md:gap-x-2">
                              {offer.title === 'Annonces gratuites' ? (
                                <span className="text-xs md:text-md lg:text-base font-semibold text-center text-neutral-700 truncate">
                                  {offer.title}
                                  <span
                                    className="text-sm ml-2 cursor-pointer underline"
                                    onClick={handleFirstSectionRedirection}
                                  >
                                    (limitées)
                                  </span>
                                </span>
                              ) : (
                                <span className="text-xs md:text-md lg:text-base font-semibold text-center text-neutral-700 truncate">
                                  {offer.title}
                                </span>
                              )}
                              <div className="block lg:group-hover:block xl:hidden ">
                                <Tooltip component={<DescriptionPopoverInfo />}>
                                  <BsQuestionCircle
                                    size={12}
                                    className="text-neutral-700"
                                  />
                                </Tooltip>
                              </div>
                            </td>
                            {windowSize.width > 1200 && (
                              <td className="!p-0 w-[30rem] flex justify-start items-center">
                                {offer.description ===
                                'Booster vos produits grâce aux services proposés sur le site.' ? (
                                  <span className="text-xs md:text-sm text-start text-neutral-700">
                                    {offer.description} *
                                    <span
                                      className="text-xs font-semibold ml-2 cursor-pointer underline"
                                      onClick={handleSecondSectionRedirection}
                                    >
                                      (Voir offres)
                                    </span>
                                  </span>
                                ) : (
                                  <span className="text-xs md:text-sm text-start text-neutral-700">
                                    {offer.description}
                                  </span>
                                )}
                              </td>
                            )}
                            <td className="!p-0 w-[7rem] md:w-[9rem] flex justify-center items-center">
                              {offer.individual ? (
                                <MdCheck
                                  size={25}
                                  className={'text-green-600'}
                                />
                              ) : (
                                <MdClose size={25} />
                              )}
                            </td>
                            <td className="!p-0 w-[7rem] md:w-[9rem] flex justify-center items-center">
                              {offer.profesional ? (
                                <MdCheck
                                  size={25}
                                  className={'text-green-600'}
                                />
                              ) : (
                                <MdClose size={25} />
                              )}
                            </td>
                          </tr>
                        );
                      })}
                    </React.Fragment>
                  ))}
                </tbody>
                <Text
                  text="* Certains formats de boost sont exclusifs aux professionnels."
                  as="h3"
                  className="text-xs md:text-sm font-light text-start text-neutral-700 my-6 md:pl-4"
                />
              </table>
            </div>
          </div>
        </div>
      </div>
      <div className="flex flex-col items-center justify-center  w-full mx-auto pb-10">
        <Text
          text="Vous avez une question?"
          as="h3"
          className="text-lg font-bold text-center text-neutral-700 mt-12"
        />
        <a
          href={'/contact'}
          target="_blank"
          className=" text-sm lg:text-sm xl:text-base text-center underline text-neutral-700 mt-2 "
        >
          Contactez-nous
        </a>
        <div className="flex text-neutral-700 flex-col items-center ">
          <span className=" flex flex-col items-center text-center">
            <span className="text-sm my-2 font-light italic">Ou</span> Veuillez
            contacter le
            <span className="flex items-center gap-x-1 mt-1 font-bold text-stone-600 ">
              <HiPhone size={16} className="mt-[1px]" />
              +216 95 256 201{' '}
            </span>
          </span>
        </div>
      </div>
    </>
  );
};
